import { useLocation, Outlet } from 'react-router-dom'
import { useTelegramWebApp } from '../../hooks/useTelegramWebApp'
import Header from './Header'
import BottomMenu from '../BottomMenu/BottomMenu'
import './Layout.css'

const Layout = () => {
  const location = useLocation()
  const { webApp } = useTelegramWebApp()

  // На главной шапка (логотип, счётчик, аватар) отрисована внутри баннера,
  // поэтому отдельный Header там не нужен.
  const showHeader =
    location.pathname !== '/profile' && location.pathname !== '/'

  return (
    <div className="layout">
      {showHeader && <Header />}
      <main className="main-content">
        <Outlet />
      </main>
      <BottomMenu />
    </div>
  )
}

export default Layout
